import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiRefreshCw, FiMapPin, FiClock } from 'react-icons/fi';
import './SystemLogs.css';

const SystemLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const pageSize = 100;

  useEffect(() => {
    fetchLogs();
  }, [filter, page]);

  const fetchLogs = async () => {
    try {
      const params = {};
      if (filter !== 'all') {
        params.action = filter;
      }
      params.page = page;
      params.page_size = pageSize;
      const response = await axios.get('/api/logs/system/', { params });
      if (Array.isArray(response.data)) {
        // без пагинации (fallback)
        setLogs(response.data);
        setCount(response.data.length);
      } else {
        setLogs(response.data.results || []);
        setCount(response.data.count || 0);
      }
    } catch (error) {
      toast.error('Ошибка загрузки логов');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div className="system-logs-page">
      <div className="page-header">
        <h1>Системные логи</h1>
        <div className="header-actions">
          <select
            className="form-select"
            value={filter}
            onChange={(e) => {
              setPage(1);
              setFilter(e.target.value);
            }}
            style={{ width: '200px' }}
          >
            <option value="all">Все действия</option>
            <option value="video_viewed">Просмотры видео</option>
            <option value="comment_added">Комментарии</option>
            <option value="like_added">Лайки</option>
            <option value="user_login">Входы</option>
            <option value="user_logout">Выходы</option>
            <option value="email_sent">Отправка email</option>
          </select>
          <button className="btn btn-outline" onClick={fetchLogs}>
            <FiRefreshCw /> Обновить
          </button>
        </div>
      </div>

      <div className="logs-container">
        <table className="table">
          <thead>
            <tr>
              <th>Дата и время</th>
              <th>Действие</th>
              <th>IP адрес</th>
              <th>Страна</th>
              <th>Город</th>
              <th>Детали</th>
            </tr>
          </thead>
          <tbody>
            {logs.length > 0 ? (
              logs.map((log) => (
                <tr key={log.id}>
                  <td>
                    <div className="log-time">
                      <FiClock />
                      {new Date(log.created_at).toLocaleString('ru-RU')}
                    </div>
                  </td>
                  <td>
                    <span className="action-badge">{log.action}</span>
                  </td>
                  <td>{log.ip_address}</td>
                  <td>
                    {log.country && (
                      <div className="geo-info">
                        <FiMapPin />
                        {log.country}
                      </div>
                    )}
                  </td>
                  <td>{log.city || '-'}</td>
                  <td>
                    {log.details && Object.keys(log.details).length > 0 ? (
                      <details className="log-details">
                        <summary>Детали</summary>
                        <pre>{JSON.stringify(log.details, null, 2)}</pre>
                      </details>
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="empty-state">
                  <p>Нет логов</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="logs-pagination">
        <div className="logs-pagination-info">
          {count > 0 ? (
            <>
              Показано {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, count)} из {count}
            </>
          ) : (
            'Нет логов'
          )}
        </div>
        {count > pageSize && (
          <div className="logs-pagination-controls">
            <button
              className="btn btn-outline"
              disabled={page === 1}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
            >
              Назад
            </button>
            <span className="logs-page-number">Страница {page}</span>
            <button
              className="btn btn-outline"
              disabled={page * pageSize >= count}
              onClick={() => setPage((p) => p + 1)}
            >
              Вперёд
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SystemLogs;
